import './index.scss';
import React, { useEffect, useState } from 'react';
import Utils from '../../CourseApp/Helper/utils';

function RadioControl({structure, saveValue, defaultValue, controlKey, runtimeValue, selectedSlide}){
    const [controlValue, setControlValue] = useState(defaultValue ?? false);
    const [isChanging, setIsChanging] = useState(false);
    const controlLabel = structure.labelOnChangeOption;

    let isShow = true;
    if (selectedSlide.template.type() === 'DocumentTemplate') {
        const relatedRequired = typeof structure.relatedRequired !== 'undefined' ? structure.relatedRequired : null;
        if (relatedRequired.attachment.type !== selectedSlide.data?.attachment?.type) {
            isShow = false;
        }
    }

    // console.log(relatedRequired);
    // console.log(selectedSlide);

    const handleToggle = () => {
        let isInMultipleQuestions = typeof selectedSlide.data?.answer !== 'undefined' ?? true;

        if (isInMultipleQuestions) {
            let isAnyCorrectAnswer = selectedSlide.data?.answer.filter(item => item.correct === true);
            if (!controlValue && isAnyCorrectAnswer.length > 0) {
                Utils.showError('Correct answer cannot more than 1');
                return false;
            }
        }

        if (!isChanging) {
            setIsChanging(true);
            // setIsOn(!controlValue);
            setControlValue(!controlValue);
            saveValue(!controlValue);

            setTimeout(() => {
                setIsChanging(false);
            }, 300); // Atur durasi timeout sesuai kebutuhan
        }
    };

    useEffect(()=>{
        if(typeof defaultValue !== 'undefined' && defaultValue !== 'false') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }
    }
    , [defaultValue]);

    return (
        <>
        {isShow && (
            <>
            <div className="tbcourse-editor-control-item-label">
                {controlLabel}
            </div>
            <div className="tbcourse-editor-control-radio">
                <div
                    className='switch-wrapper'
                    onClick={handleToggle}
                    >
                    <span className='label'>{controlValue ? structure.trueLabel : structure.falseLabel}</span>
                    <span className={`switch ${controlValue ? 'on' : 'off'} ${isChanging ? 'changing' : ''}`}>
                        <input type="checkbox" checked={Boolean(controlValue)} readOnly />
                        <span className="slider"></span>
                    </span>

                </div>
            </div>
            </>
        )}
        </>
    );
}

export default RadioControl;
